import { any } from 'prop-types';
import { useDispatch } from 'react-redux';

import { KovResourcePicker } from '@kathondvla/react-shared-components/src/components';

import type { EditAsideWebType } from '@nodeTypeConfig/configTypes';
import {
  removeWebsiteConfigurationAction,
  updateWebsiteConfigurationActionNew,
} from '@store/actions/documentActions';
import { getResourceKey } from '@store/helpers/documentHelpers';
import { useCurrentWebConfig } from '../../../hooks/UseCurrentWebConfig';
import { useEditHref } from '../../../hooks/UseEditHref';
import { useTypedSelector } from '../../../hooks/useTypedSelector';
import {
  selectIsWebTypeComponentLoading,
  selectSelectedType,
  selectWebTypeOptions,
} from './asideWebTypeSelectors';

const AsideWebType: React.FC<{
  config: EditAsideWebType;
  readonly: boolean;
}> = ({ config, readonly }) => {
  const dispatch = useDispatch();

  const editingHref = useEditHref();
  const isLoading = useTypedSelector(selectIsWebTypeComponentLoading);
  const typeOptions = useTypedSelector((state) => selectWebTypeOptions(state, editingHref));
  const selectedType = useTypedSelector((state) => selectSelectedType(state, config));
  const currentWebConfig = useCurrentWebConfig();

  const onChange = (value: typeof selectedType) => {
    if (!value) {
      // delete webconfig
      dispatch(
        removeWebsiteConfigurationAction(getResourceKey(editingHref), currentWebConfig?.key),
      );
    } else {
      dispatch(updateWebsiteConfigurationActionNew(editingHref, config.property, value.href));
    }
  };

  const addCursorStyle = (provided) => ({ ...provided, cursor: 'pointer' });

  return (
    <>
      <label className="control-label">{config.label}</label>
      {isLoading ? (
        <div className="form-group shimmer narrowLine" />
      ) : (
        <KovResourcePicker
          value={selectedType}
          localData={typeOptions}
          display="display"
          clearable={true}
          disabled={readonly}
          disableSearch={true}
          noOptionsMessage={() => 'Geen geldige types beschikbaar'}
          style={{ option: addCursorStyle, valueContainer: addCursorStyle }}
          onChange={onChange}
        />
      )}
    </>
  );
};

AsideWebType.displayName = 'AsideWebType';

AsideWebType.propTypes = { config: any };

export default AsideWebType;
